import { render, staticRenderFns } from "./DialogBookJson.vue?vue&type=template&id=2478b43e&scoped=true"
import script from "./DialogBookJson.vue?vue&type=script&lang=js"
export * from "./DialogBookJson.vue?vue&type=script&lang=js"
import style0 from "./DialogBookJson.vue?vue&type=style&index=0&id=2478b43e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2478b43e",
  null
  
)

export default component.exports